import React, { useState, useRef, useEffect } from "react";
import "./LayerFilterMin.css";
import { geoserverUrl, geoWorkspace } from "../../../../_config/layers/zcm";
import { fromLonLat } from "ol/proj";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { getLayerAttributes } from "../../../../_config/layers/zcm";


var wfsData = [];

const LayerFilterMin = (props) => {
  const { t } = useTranslation();

  const wmsName = props.wmsName;

  const LayerFilterMinHandlerRef = useRef();

  const layerInputAttributeSelect = useRef();

  const layerInputOperatorSelect = useRef();

  const LayerFilterMinInput = useRef();

  const [layerOperators, setLayerOperators] = useState([]);

  const [layerAttributesOptions, setLayerAttributesOptions] = useState([]);

  const [layerAttributes, setLayerAttributes] = useState([]);

  const [layerAttributesTypes, setLayerAttributesTypes] = useState([]);

  const [dialogVisible, setDialogVisible] = useState(false);

  const handleLayerFilterMinClick = (e) => {
    let display = LayerFilterMinHandlerRef.current.style.display;

    if (display === "none" || display === "") {
      if (layerAttributes.length == 0) fetchLayerAttributes();

      LayerFilterMinHandlerRef.current.style.display = "block";
    } else {
      LayerFilterMinHandlerRef.current.style.display = "none";
    }
  };

  const handleLayerFilterMinUpdaterClick = (e) => {
    let attribute = layerAttributes[
      layerInputAttributeSelect.current.value
    ].replace(":", "");
    let attributeType =
      layerAttributesTypes[layerInputAttributeSelect.current.value];
    let operator = layerInputOperatorSelect.current.value;
    let filterValue = formatFilterValue(
      attributeType,
      operator,
      LayerFilterMinInput.current.value
    );

    var filter = attribute + " " + operator + " " + filterValue;

    ///console.log(filter)
    // by default, reset all filters
    var filterParams = {
      FILTER: null,
      CQL_FILTER: null,
      FEATUREID: null,
    };

    if (filter.replace(/^\s\s*/, "").replace(/\s\s*$/, "") != "") {
      filterParams["CQL_FILTER"] = filter;
    }
    // merge the new filter definitions
    props.layer.getSource().updateParams(filterParams);
  };

  const formatFilterValue = (type, operator, filterValue) => {
    //console.log(type)

    if (
      type.search(`double`) !== -1 ||
      type.search(`int`) !== -1 ||
      type.search(`numeric`) !== -1 ||
      type.search(`decimal`) !== -1 ||
      type.search(`real`) !== -1 ||
      type.search(`serial`) !== -1
    )
      return filterValue;
    else if (operator === `ilike`) return `'%${filterValue}%'`;
    else return `'${filterValue}'`;
  };

  const handleLayerFilterMinReseterClick = () => {
    var filterParams = {
      FILTER: null,
      CQL_FILTER: null,
      FEATUREID: null,
    };

    props.layer.getSource().updateParams(filterParams);
  };

  const fetchLayerAttributes = async () => {

    try {
      const { wfsAttributes } = await getLayerAttributes(wmsName.split(':')[1]);

      let str = wfsAttributes;

      let attributes = str.match(/[\w]{1,}:/g);

      let attributesTypes = str.match(/[\w]{1,},/g);

      if (
        attributes &&
        attributes[0] &&
        attributesTypes &&
        attributesTypes[0]
      ) {
        try {
          setLayerAttributes(attributes);
          setLayerAttributesTypes(attributesTypes);
          setLayerOperators(buildLayerOperators());
          buildLayerAttributeOptions(attributes)
        } catch (e) {
          console.log(e);
        }
      }
    } catch (err) {
      console.error('getLayerAttributes failed:', err);
      setLayerAttributes('');
    }
  };

  const buildLayerAttributeOption = (attribute, id) => {
    attribute = attribute.replace(":", "");

    return (
      <option key={id} className={"LayerOperator"} value={id}>
        {attribute}
      </option>
    );
  };

  const buildLayerAttributeOptions = (attributes) => {
    
    return setLayerAttributesOptions(
      attributes.map((attribute, key) =>
        buildLayerAttributeOption(attribute, key)
      )
    );
  };

  const buildLayerOperator = (operator, id) => {
    return (
      <option key={id} className={"LayerOperator"} value={operator[0]}>
        {operator[1]}
      </option>
    );
  };

  const buildLayerOperators = () => {
    const layerOperators = [
      [`=`, `Igual`],
      [`ilike`, `Contém`],
      [`<>`, `Diferente`],
      [`>`, `Maior`],
      [`>=`, `Maior igual`],
      [`<`, `Menor`],
      [`<=`, `Menor igual`],
    ];

    return layerOperators.map((operator, key) =>
      buildLayerOperator(operator, key)
    );
  };

  /** TABULAR FEATURES*/

  const [modalValue, setModalValue] = useState("");

  const handleLayerTabularFilterUpdaterClick = async (e) => {
    let attribute = layerAttributes[
      layerInputAttributeSelect.current.value
    ].replace(":", "");
    let attributeType =
      layerAttributesTypes[layerInputAttributeSelect.current.value];
    let operator = layerInputOperatorSelect.current.value;
    let filterValue = formatFilterValue(
      attributeType,
      operator,
      LayerFilterMinInput.current.value
    );

    var filter = attribute + " " + operator + " " + filterValue;

    //console.log(filter)
    // by default, reset all filters
    var filterParams = {
      FILTER: null,
      CQL_FILTER: null,
      FEATUREID: null,
    };

    if (filter.replace(/^\s\s*/, "").replace(/\s\s*$/, "") != "") {
      filterParams["CQL_FILTER"] = filter;
    }
    // merge the new filter definitions
    let wfsInfo = await requestWFSInfo(
      props.layer.get("wmsName").split(":")[1],
      filter
    );

    setModalValue([
      <Button
        severity="success"
        raised
        className="BtnExport"
        onClick={handleExportCSV}
      >
        Exportar
      </Button>,
      wfsInfo,
    ]);

    setDialogVisible(true);
  };

  const requestWFSInfo = async (layerName, filter) => {
    const url = `${geoserverUrl}/wfs?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&CQL_FILTER=${encodeURIComponent(
      filter
    )}`;
    wfsData = [];
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      wfsData.push(...data.features);

      return craftTable(data.features);
    } catch (error) {
      console.error("Error fetching WFS data:", error);
      return craftTable([]);
    }
  };

  const craftTable = (wfsData) => {
    if (wfsData.length === 0) {
      return <p>No data available</p>;
    }

    return (
      <table className="table">
        <thead>
          <tr>
            {Object.keys(wfsData[0].properties).map((key) => (
              <th key={key}>{key}</th>
            ))}
            <th>Localizador</th>
          </tr>
        </thead>
        <tbody>
          {wfsData.map((feature, index) => (
            <tr key={index}>
              {Object.values(feature.properties).map((value, i) => (
                <td key={i}>{value}</td>
              ))}
              <td>
                {/* Botão que dá zoom na feature no mapa */}
                <Button
                  severity="info"
                  className="BtnZoom"
                  raised
                  onClick={() => zoomToFeature(props.map, feature)}
                >
                  Zoom
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const zoomToFeature = (map, feature) => {
    const geometry = feature.geometry;
    const type = geometry.type;
    let coordinates = geometry.coordinates;

    if (type === "Point") {
      // Para ponto, apenas converte a coordenada para EPSG:4326 e dá zoom
      const transformedCoordinates = fromLonLat(coordinates, "EPSG:4326");
      map.getView().animate({
        center: transformedCoordinates,
        duration: 1000,
        zoom: 15,
      });
    } else if (
      type === "Polygon" ||
      type === "LineString" ||
      type === "MultiPolygon" ||
      type === "MultiLineString"
    ) {
      // Para Polygon, LineString, MultiPolygon e MultiLineString, transforma as coordenadas
      let transformedCoordinates = coordinates.map((coord) =>
        fromLonLat(coord, "EPSG:4326")
      );

      // Para Polygon e MultiPolygon, transforma o primeiro anel de coordenadas (a borda externa)
      if (type === "Polygon") {
        transformedCoordinates = transformedCoordinates[0]; // A borda externa do polígono
      } else if (type === "MultiPolygon") {
        transformedCoordinates = transformedCoordinates.flatMap(
          (polygon) => polygon[0]
        ); // A borda externa de todos os polígonos
      }

      // Para MultiLineString, precisamos aplainar o array de coordenadas
      if (type === "MultiLineString") {
        transformedCoordinates = transformedCoordinates.flat();
      }

      //console.log(fromLonLat(transformedCoordinates[0], 'EPSG:4326'))

      // Ajustar a visão do mapa para que toda a geometria fique visível
      try {
        props.map.getView().animate({
          center: fromLonLat(transformedCoordinates[0], "EPSG:4326"),
          duration: 1000,
          zoom: 10,
        });
      } catch (e) {
        console.log(e);
      }
    }
  };

  const convertToCSV = () => {
    //console.log(wfsData)
    if (!wfsData || wfsData.length === 0) return "";

    const headers = Object.keys(wfsData[0].properties).join(";"); // Cabeçalhos do CSV
    const rows = wfsData.map((feature) =>
      Object.values(feature.properties).join(";")
    ); // Linhas de dados
    return [headers, ...rows].join("\n"); // Junta os cabeçalhos e linhas
  };

  const downloadCSV = (csvData, fileName) => {
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportCSV = () => {
    const csvData = convertToCSV();
    downloadCSV(csvData, `data.csv`);
  };

  return (
    <>
      <a className={"LayerFilterMin"} href="#" rel="noreferrer">
        <Button
          className="HorizontalButton"
          onClick={handleLayerFilterMinClick}
          title={t("layerfilter.buttonTitle")}
          alt={t("layerfilter.buttonAlt")}
          icon="pi pi-filter"
        ></Button>
      </a>

      <div
        id="LayerFilterMinHandler"
        ref={LayerFilterMinHandlerRef}
        className={"LayerFilterMinHandler"}
      >
        <span>{t("layerfilter.label")}</span>

        <div className="ContainerSelects">
          <select
            ref={layerInputAttributeSelect}
            className="form-select SelectFilter LayerFilterMinHandlerInput"
          >
            <option value="">{t("layerfilter.attributePlaceholder")}</option>
            {layerAttributesOptions}
          </select>



          <select
            ref={layerInputOperatorSelect}
            className="form-select SelectFilter LayerFilterMinHandlerInput"
          >
            <option value="">{t("layerfilter.operatorPlaceholder")}</option>
            {layerOperators}
          </select>
        </div>

        <div className="ContainerInput">
          <InputText
            ref={LayerFilterMinInput}
            placeholder={t("layerfilter.valuePlaceholder")}
            className="inputTxt"
          />
        </div>

        <div className="ContainerBtnsFilter">
          <Button
            label={t("layerfilter.filterButton")}
            onClick={handleLayerFilterMinUpdaterClick}
            severity="success"
          />
          <Button
            label={t("layerfilter.modalTitle")}
            onClick={handleLayerTabularFilterUpdaterClick}
            severity="success"
          />
          <Button
            label={t("layerfilter.resetButton")}
            onClick={handleLayerFilterMinReseterClick}
            severity="success"
          />
        </div>

        <Dialog
          header={t("layerfilter.modalTitle")}
          visible={dialogVisible}
          style={{ width: "70vw" }}
          modal
          onHide={() => setDialogVisible(false)}
          className="FeatureInfoDialog"
          position="right"
        >
          {modalValue}
        </Dialog>
      </div>
    </>
  );
};

export default LayerFilterMin;
